const CONFIG = {
  SearchDriversProgression: {
    filterType: 'periods',
    type: 'SearchKeywords',
    attributeColor: '#000',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Periodic View' },
    ],
    showLegends: false,
  },
  DriversProgressionWithoutSentiments: {
    filterType: 'periods',
    type: 'SearchKeywords',
    attributeColor: '#000',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Periodic View' },
    ],
    showLegends: false,
  },
  SegmentDriversOnlyAnalysisWithoutSentiments: {
    filterType: 'periods',
    type: 'SearchKeywords',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: true,
  },
  DriversProgression: {
    filterType: 'periods',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Periodic View' },
    ],
    showLegends: true,
  },
  SegmentDriversOnlyAnalysis: {
    filterType: 'periods',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: true,
  },
  SegmentDriversAnalysis: {
    filterType: 'periods',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: true,
  },
  // SearchDriversProgression3Level
  SearchDriversProgression3Level: {
    filterType: 'segments',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: true,
  },
  SegmentDriversOnlyAnalysis3Level: {
    filterType: 'segments',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: true,
  },
  SegmentDriversOnlyAnalysisWithoutSentiments3Level: {
    type: 'SearchKeywords',
    filterType: 'segments',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: false,
  },
  Triangulation: {
    filterType: 'periods',
    tabs: [
      { id: 0, label: 'Comparison View' },
      { id: 1, label: 'Segment View' },
    ],
    showLegends: true,
  },
  TriangulationComparisonViewOnly: {
    filterType: 'periods',
    tabs: [{ id: 0, label: 'Comparison View' }],
    showLegends: true,
  },
}

export default CONFIG